import { IconProps } from "./Icon.model";

export function TimeSchedule({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;
  const fillColorLight =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a6)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00004 4.66663C8.36823 4.66663 8.66671 4.9651 8.66671 5.33329V7.72382L9.47145 8.52856C9.73179 8.7889 9.73179 9.21101 9.47145 9.47136C9.2111 9.73171 8.78899 9.73171 8.52864 9.47136L7.52864 8.47136C7.40361 8.34634 7.33337 8.17677 7.33337 7.99996V5.33329C7.33337 4.9651 7.63185 4.66663 8.00004 4.66663Z"
        fill={fillColor}
      />
      <path
        d="M12.4949 10.1115L13.305 10.5489C13.8188 10.8263 14.2563 11.0626 14.5603 11.2937C14.8792 11.5362 15.1667 11.8595 15.1667 12.3333C15.1667 12.8071 14.8792 13.1303 14.5603 13.3729C14.2563 13.604 13.8188 13.8402 13.305 14.1177L13.305 14.1177L12.4949 14.5551C12.1017 14.7674 11.766 14.9488 11.5032 15.0524C11.3677 15.1059 11.2136 15.1547 11.0562 15.1647C10.8865 15.1755 10.6866 15.142 10.5131 15.0003C10.2357 14.7739 10.1581 14.4624 10.1675 14.1944C10.1764 13.9428 10.2602 13.6963 10.3467 13.4963C10.436 13.2899 10.5466 13.092 10.6403 12.9317C10.6783 12.8668 10.7111 12.8117 10.7394 12.7642L10.7394 12.7642C10.7886 12.6818 10.824 12.6224 10.8488 12.5741C10.9305 12.415 10.9361 12.3567 10.936 12.3323C10.9359 12.3074 10.9298 12.2502 10.8488 12.0925C10.824 12.0442 10.7886 11.9848 10.7394 11.9024L10.7394 11.9024C10.7111 11.8549 10.6783 11.7998 10.6403 11.7349C10.5466 11.5746 10.436 11.3767 10.3467 11.1703C10.2602 10.9703 10.1764 10.7238 10.1675 10.4722C10.1581 10.2042 10.2357 9.89272 10.5131 9.66625C10.6866 9.52458 10.8865 9.49105 11.0562 9.50188C11.2136 9.51192 11.3677 9.56069 11.5032 9.61416C11.766 9.7178 12.1017 9.89914 12.4949 10.1115L12.4949 10.1115Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00004 2.1364C4.76164 2.1364 2.1364 4.76164 2.1364 8.00004C2.1364 11.2384 4.76164 13.8637 8.00004 13.8637C8.20365 13.8637 8.40462 13.8533 8.6025 13.8332C8.96047 13.7967 9.28024 14.0573 9.31673 14.4152C9.35321 14.7732 9.0926 15.093 8.73463 15.1295C8.49293 15.1541 8.24785 15.1667 8.00004 15.1667C4.042 15.1667 0.833374 11.9581 0.833374 8.00004C0.833374 4.042 4.042 0.833374 8.00004 0.833374C11.9581 0.833374 15.1667 4.042 15.1667 8.00004C15.1667 8.49006 15.1174 8.96924 15.0234 9.43268C14.9518 9.78531 14.6079 10.0131 14.2553 9.94156C13.9026 9.86998 13.6748 9.52609 13.7464 9.17346C13.8232 8.79486 13.8637 8.40251 13.8637 8.00004C13.8637 4.76164 11.2384 2.1364 8.00004 2.1364Z"
        fill={fillColorLight}
      />
    </svg>
  );
}

